<template>
    <!-- Formulario -->
    <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-0 bg-white" role="tab">
            <b-button block variant="none" class="d-flex justify-content-between align-items-center" @click="setIsShowingForm(!isShowingForm)">
                <div class="p-2 text-left">
                    <strong class="d-flex align-items-center">
                        <b-avatar :variant="selectedLayout.is_published ? 'info' : 'dark'" size="sm" class="d-flex align-items-center justify-content-center mr-1">
                            <i :class="`fa ${selectedLayout.is_published ? 'fa-check' : 'fa-close'}`"></i>
                        </b-avatar>
                        Datos de la etiqueta
                    </strong>
                    <div class="mt-2 d-flex align-items-center">
                        <!-- Nombre de la empresa -->
                        <span class="py-1 px-2 rounded bg-light">
                            <i :class="`fa ${getNameCompany ? 'fa-building' : 'fa-globe'} mr-1`"></i>
                            {{ getNameCompany || 'Diseño general' }}
                        </span>
                    </div>
                </div>
                <b-button class="d-flex align-items-center" variant="light">
                    <i :class="`fa fa-${isShowingForm ? 'chevron-left' : 'chevron-right'}`"></i>
                    <span v-if="!isShowingForm" class="ml-2">
                        Mostrar formulario
                    </span>
                </b-button>
            </b-button>
        </b-card-header>
        <div class="bg-white rounded pt-3" v-if="isShowingForm">
            <b-form @submit.prevent="() => { }" data-vv-scope="formDesigner">

                <b-row class="m-0 p-0">

                    <!-- Titulo -->
                    <b-col cols="12">
                        <b-form-group>
                            <label for="width"><i class="fa fa-font mr-2"></i>Titulo: <span class="text-danger">(*)</span></label>
                            <b-form-input v-model="selectedLayout.title" id="title" type="text" :disabled="hasBlockFields"></b-form-input>
                            <span class="text-danger small" v-text="errors.first('formDesigner.title')" />
                        </b-form-group>
                    </b-col>

                    <!-- Seleccionar países de aplicación: -->
                    <b-col md="12">
                        <b-form-group>
                            <label for="countries_ids"><i class="fa fa-globe mr-2"></i>Seleccionar países de aplicación: </label>
                            <el-select v-model="selectedLayout.countries_ids" clearable filterable multiple :disabled="hasBlockFields"
                                size="medium" placeholder="Seleccionar países" name="countries_ids" v-validate="''"
                                data-vv-as=" ">
                                <el-option v-for="item in countries" :key="item.id" :label="item.name"
                                    :value="item.id" />
                            </el-select>
                        </b-form-group>
                    </b-col>

                    <!-- Seleccionar empresa -->
                    <b-col cols="12">
                        <b-form-group v-show="!selectedLayout.id">
                            <label for="width"><i class="fa fa-building mr-2"></i>Seleccionar empresa: </label>
                            <el-select v-model="selectedLayout.company_id" filterable remote clearable :disabled="hasBlockFields"
                                no-data-text="No hay datos que coincidan" no-match-text="No hay datos que coincidan"
                                :remote-method="onHandleSearchCompany" :loading="globalLoading">
                                <el-option v-for="company in companies" :key="company.id" :label="company.nombre"
                                    :value="company.id">
                                </el-option>
                            </el-select>
                        </b-form-group>
                    </b-col>

                    <!-- Ancho -->
                    <b-col cols="12">
                        <b-form-group>
                            <b-row>
                                <b-col cols="3">
                                    <label for="width" class="mt-2">Ancho: <span class="text-danger">(*)</span></label>
                                </b-col>
                                <b-col cols="9">
                                    <el-input-number placeholder="Ancho" v-model="selectedLayout.gridWidthCm" :min="4"
                                        :max="10000" :step="0.5" :disabled="hasBlockFields" />
                                    <b-badge class="ml-2" :variant="hasBlockFields ? 'info' : 'dark'">CM</b-badge>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>

                    <!-- Alto -->
                    <b-col cols="12">
                        <b-form-group>
                            <b-row>
                                <b-col cols="3">
                                    <label for="height" class="mt-2">Alto: <span class="text-danger">(*)</span></label>
                                </b-col>
                                <b-col cols="9">
                                    <el-input-number placeholder="Alto" v-model="selectedLayout.gridHeightCm" :min="4"
                                        :max="10000" :step="0.5" :disabled="hasBlockFields" />
                                    <b-badge class="ml-2" :variant="hasBlockFields ? 'info' : 'dark'">CM</b-badge>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>

                    <!-- Configuración de países seleccionados -->
                    <b-col cols="12">
                        <b-alert show variant="secondary" class="my-2 border-0">
                            <strong><i class="fa fa-pencil-square-o mr-2"></i>Configuración por País</strong>
                            <hr>
                            
                            <b-form-group label="Selecciona un país para configurar:">
                                <b-form-select v-model="selectedCountryToConfig" :options="countryOptionsToConfig" :disabled="hasBlockFields">
                                    <template #first>
                                        <b-form-select-option :value="null" disabled>-- Selecciona un país --</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-form-group>
                            
                            <div v-if="selectedCountryToConfig">
                                <label class="font-weight-bold">
                                    {{ getCountryName(selectedCountryToConfig) }} - Texto guía de descarga:
                                </label>
                                <b-form-textarea
                                    v-model="countryConfigs[selectedCountryToConfig]"
                                    placeholder="Ingrese el texto guía (opcional)"
                                    rows="3"
                                    max-rows="6"
                                    :disabled="hasBlockFields"
                                ></b-form-textarea>
                            </div>
                        </b-alert>
                    </b-col>

                    <!-- Orientación (Vertical/Horizontal) -->
                    <b-col cols="12" class="mt-2">
                        <div class="d-block mb-2" v-b-tooltip.hover title="La orientación de la hoja se reflejará en el momento de imprimir la etiqueta.">
                            <label for="orientation"><strong><i class="fa fa-file-o mr-2"></i>Orientación de la Hoja</strong></label>
                            <div>
                                <el-switch
                                    :disabled="hasBlockFields"
                                    v-model="toggleCheckOrientation"
                                    @change="onChangeToggleOrientation"
                                    class="ml-2"
                                    inline-prompt
                                    active-text="Vertical"
                                    inactive-text="Horizontal"
                                />
                            </div>
                        </div>
                    </b-col>

                    <!-- Publicar o despublicar -->
                    <b-col cols="12" class="my-2">
                        <b-form-group class="d-block mb-2">
                            <label for="orientation"><strong><i class="fa fa-globe mr-2"></i>Estado de publicación</strong></label>
                            <div v-b-tooltip.hover :title="!userHasPermissionToChangePublishedState ? 'Una vez publicado el diseño, estará disponible desde el producto para su descarga. Ten en cuenta que, después de publicarlo, no será posible editar el formato.': 'Estado de publicación del diseño'" v-if="hasBlockBtnFormFields">
                                <el-switch                                   
                                    v-model="isPublishedBoolean"
                                    class="ml-2"
                                    inline-prompt
                                    active-text="Publicada"
                                    inactive-text="No publicada"
                                />
                            </div>
                            <div v-else>
                                <b-badge class="d-block" variant="success p-2 text-white">
                                    <i class="fa fa-check"></i>
                                    Diseño Publicado
                                </b-badge>
                                <b-alert variant="light" show class="mt-1">
                                    El diseño se encuentra publicado. Para realizar cambios, contacta a un superadministrador y solicita el desbloqueo.
                                </b-alert>
                            </div>
                        </b-form-group>
                    </b-col>

                    <b-col cols="12" class="my-2" v-if="hasBlockBtnFormFields">
                        <b-button type="button" class="text-white" :variant="hasBlockFields ? 'info' : 'dark'" block @click="onHandleStoreLabelDesign">
                            <i class="fa fa-check"></i>
                            <span class="ml-2">{{ selectedLayout.id ? 'Guardar cambios' : 'Crear diseño' }}</span>
                        </b-button>
                    </b-col>

                </b-row>

            </b-form>
        </div>
    </b-card>
</template>

<script>

// Generales
import { mapState, mapMutations, mapActions } from 'vuex';

// Mixins
import { IsBlockDesignFormMixin } from '@/servicios/labelDesigner/mixins/IsBlockDesignFormMixin';

export default {

    name: 'FormLabelDesigner',

    mixins: [IsBlockDesignFormMixin],

    props: {
        generatedHtml: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            toggleCheckOrientation: true,
            countryConfigs: {},
            selectedCountryToConfig: null
        }
    },

    computed: {

        ...mapState('countries', ['countries']),

        ...mapState("Reporteinventario", {
            companies: 'listaEmpresas'
        }),

        ...mapState("dashboard", {
            globalLoading: 'cargando_datos_select'
        }),

        ...mapState('labelDesigner', [
            'selectedLayout',
            'isShowingForm'
        ]),

        ...mapState('empresa', {
            selectedCompanyToPersonalizedFields: 'selectedEmpresa'
        }),

        getNameCompany() {
            const company = this.companies.find(company => company.id === this.selectedLayout.company_id);
            return company ? company.nombre : null;
        },

        hasBlockBtnFormFields() {
            if (this.userHasPermissionToChangePublishedState) return true
            if (!this.userHasPermissionToChangePublishedState && this.selectedLayout.id && !this.selectedLayout.is_published) return true
            if (!this.userHasPermissionToChangePublishedState && !this.selectedLayout.id) return true
            return false
        },

        isPublishedBoolean: {
            get() {
                return Boolean(this.selectedLayout.is_published_temporary);
            },
            set(value) {
                this.selectedLayout.is_published_temporary = value ? 1 : 0;
            }
        },

        countryOptionsToConfig() {
            if (!this.selectedLayout.countries_ids || !this.selectedLayout.countries_ids.length) return [];
            return this.selectedLayout.countries_ids.map(id => ({
                value: id,
                text: this.getCountryName(id)
            }));
        },

        hasCountryConfigVisible() {
            if (!this.selectedLayout || !this.selectedLayout.layout) return false;
            
            return this.selectedLayout.layout.some(section => section.code === 'COUNTRY');
        }

    },

    async mounted() {
        await this.loadCountries();
        // Inicializar el toggle con el valor actual de orientation (por defecto true si es undefined)
        this.toggleCheckOrientation = this.selectedLayout.orientation !== undefined 
            ? Boolean(this.selectedLayout.orientation) 
            : true;
        
        // Si orientation no está definido, establecer el valor por defecto
        if (this.selectedLayout.orientation === undefined) {
            this.setSelectedLayout({ ...this.selectedLayout, orientation: true });
        }
    },

    watch: {

        selectedLayout: {
            handler(next, prev) {
                if (next === prev) return;

                this.countryConfigs = {};
                this.selectedCountryToConfig = null;
                if (next && next.countries && next.countries.length) {
                    next.countries.forEach(country => {
                        if (country.pivot && country.pivot.download_guide_text) {
                            const countryId = country.slq_country_id || country.pivot.country_id || country.id;
                            this.$set(this.countryConfigs, countryId, country.pivot.download_guide_text);
                        }
                    });
                }
            },
            immediate: true
        },

        async 'selectedLayout.company_id'(next, prev) {
            
            this.resetPersonalizedFields()
            this.setSelectedCompanyToPersonalizedFields({ ...this.selectedCompanyToPersonalizedFields, id: next })

            if (next && next !== prev) {                
                await this.getPersonalizedFields()
            }
        },

        'selectedLayout.orientation'(next, prev) {
            if (next !== prev) {
                // Si next es undefined, usar true como valor por defecto
                this.toggleCheckOrientation = next !== undefined ? Boolean(next) : true;
            }
        }

    },

    methods: {
        getCountryName(id) {
            const country = this.countries.find(c => c.id === id);
            return country ? country.name : 'País desconocido';
        },
        
        ...mapMutations('labelDesigner', [
            'setSelectedLayout',
            'setIsShowingForm'
        ]),

        ...mapMutations('empresa', {
            setSelectedCompanyToPersonalizedFields: 'setDatosEmpresa',
            resetPersonalizedFields: 'resetCamposPersonalizados'
        }),

        ...mapActions('countries', ['loadCountries']),

        ...mapActions("Reporteinventario", {
            getCompanies: 'getEmpresas'
        }),

        ...mapActions('labelDesigner', {
            storeLabelDesign: 'store',
            updateLabelDesign: 'update'
        }),

        ...mapActions('empresa', {
            getPersonalizedFields: 'getCamposPersonalizado'
        }),

        onChangeToggleOrientation(value) {
            this.setSelectedLayout({ ...this.selectedLayout, orientation: Boolean(value) })
        },

        async onHandleSearchCompany(nombre) {
            if (!(nombre.length >= 1)) return

            await this.getCompanies({ nombre: nombre });
        },

        async onHandleStoreLabelDesign() {
            
            // Preparar mapeo de países
            let countriesMapping = {};
            if (this.selectedLayout.countries_ids && this.selectedLayout.countries_ids.length) {
                this.selectedLayout.countries_ids.forEach(id => {
                    countriesMapping[id] = this.countryConfigs[id] || '';
                });
            }

            let payload = {
                title: this.selectedLayout.title,
                width: this.selectedLayout.gridWidthCm,
                height: this.selectedLayout.gridHeightCm,
                company_id: this.selectedLayout.company_id,
                countries_mapping: countriesMapping,
                countries_ids: this.selectedLayout.countries_ids,
                data: {
                    layout: this.selectedLayout.layout,
                    countries_ids: this.selectedLayout.countries_ids,
                    company_id: this.selectedLayout.company_id,
                    orientation: Boolean(this.selectedLayout.orientation)
                },
                html_content: this.generatedHtml,
                is_published: this.selectedLayout.is_published_temporary ? 1 : 0,
                callback: this.callbackSaveDesign
            }

            if (this.selectedLayout.id) await this.updateLabelDesign({ ...payload, id: this.selectedLayout.id })
            else await this.storeLabelDesign(payload);

        },

        callbackSaveDesign(status, { response, payload}) {
            if (!status) return

            let id = (typeof response === 'object' && 'id' in response) ? response.id : payload.id

            let updatedCountries = [];
            if (this.selectedLayout.countries_ids && this.selectedLayout.countries_ids.length) {
                updatedCountries = this.selectedLayout.countries_ids.map(countryId => {
                    const existingCountry = this.countries.find(c => c.id === countryId) || { id: countryId };
                    return {
                        ...existingCountry,
                        pivot: {
                            country_id: countryId,
                            download_guide_text: this.countryConfigs[countryId] || ''
                        }
                    };
                });
            }

            this.setSelectedLayout({ 
                ...this.selectedLayout, 
                id,
                is_published: payload.is_published,
                is_published_temporary: payload.is_published,
                countries: updatedCountries
            })
        }
    }
};
</script>

<style scoped></style>